import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

export const talentsKey = (influencerId) =>
  influencerId ? `/api/influencer/${influencerId}/talents` : null;

export default function useAgentTalents(influencerId) {
  const { data, error, mutate } = useSWR(talentsKey(influencerId), fetcher);

  const talents = React.useMemo(() => {
    if (!Array.isArray(data)) {
      return [];
    }

    return data;
  }, [data]);

  return {
    error,
    talents,
    isError: Boolean(error),
    isLoading: !data && !error,
    refreshAgentTalents: mutate,
  };
}
